import { render, staticRenderFns } from "./TaskMatching.vue?vue&type=template&id=36b5092c&scoped=true"
import script from "./TaskMatching.vue?vue&type=script&lang=js"
export * from "./TaskMatching.vue?vue&type=script&lang=js"
import style0 from "./TaskMatching.vue?vue&type=style&index=0&id=36b5092c&prod&lang=css"
import style1 from "./TaskMatching.vue?vue&type=style&index=1&id=36b5092c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b5092c",
  null
  
)

export default component.exports